import axios from 'axios'
import { Dispatch, SetStateAction } from 'react';
import 'regenerator-runtime/runtime'

class Postier {
    createRole(token: string, data, setErrors: Dispatch<SetStateAction<string[]>>) {
        axios.post(`api-v0/role`,data,{headers:{ Authorization: `Bearer ${token}` }})
        .then(res=>{
            if (res.data) {
                setErrors((errors: string[]) => [...errors, "Les droits ont bien été affectés"])
            }
        }).catch(err=>{
            setErrors((errors: string[]) => [...errors, "L'affectation des droits a échoué"])
            localStorage.clear()
        }) 
    }

    getRole(token: string, setErrors: Dispatch<SetStateAction<string[]>>, setRoles) {
        axios.get(`api-v0/role`, {headers:{ Authorization: `Bearer ${token}` }})
        .then(res=>{
            setRoles(res.data.map(role => role.user_id))
        }).catch(err=>{
            setErrors((errors: string[]) => [...errors, "L'affectation des droits a échoué"])
            localStorage.clear()
        }) 
    }
}

export const SmartVisionPostier = new Postier()